export default "__VITE_ASSET__DmS4Nosq__"